var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: [{
      loaded: _vm.loading
    }]
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": _vm.loading,
      "reason": _vm.loadingReason
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "settings--section",
    staticStyle: {
      "z-index": "0"
    }
  }, [_c('div', {
    staticClass: "max-w-md section--container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.settings && _vm.hasToken ? _c('div', {
    key: "entered"
  }, [_c('img', {
    staticClass: "w-24 mb-8 rounded-full",
    attrs: {
      "src": "https://s3.extra.app/site-assets/comms-settings-icon-1.gif"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "mb-4 sm-md:h2"
  }, [_vm._v("Adjust your messaging preferences")]), _vm._v(" "), _c('p', {
    staticClass: "text-lg leading-8"
  }, [_vm._v("\n\t\t\t\t\t\tNo longer wish to receive our messages? Here’s what you might miss:\n\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "types--list"
  }, [_c('li', [_vm._v("Marketing Comms (new product alerts, feedback surveys)")]), _vm._v(" "), _c('li', [_vm._v("Reward Store Comms (sweepstakes, deals and discounts, new product drops)")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "flex flex-row items-center mb-2 space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optout_marketing_comms,
      expression: "optout_marketing_comms"
    }],
    attrs: {
      "id": "marketing",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.optout_marketing_comms) ? _vm._i(_vm.optout_marketing_comms, null) > -1 : _vm.optout_marketing_comms
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.optout_marketing_comms,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optout_marketing_comms = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.optout_marketing_comms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.optout_marketing_comms = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-lg opacity-75",
    attrs: {
      "for": "marketing"
    }
  }, [_vm._v("Opt-out of marketing communications\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.optout_rewards_store_comms,
      expression: "optout_rewards_store_comms"
    }],
    attrs: {
      "id": "rewards",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.optout_rewards_store_comms) ? _vm._i(_vm.optout_rewards_store_comms, null) > -1 : _vm.optout_rewards_store_comms
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.optout_rewards_store_comms,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optout_rewards_store_comms = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.optout_rewards_store_comms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.optout_rewards_store_comms = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-lg opacity-75",
    attrs: {
      "for": "reqards"
    }
  }, [_vm._v("Opt-out rewards store communications")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_c('button', {
    staticClass: "w-full button--filled",
    class: !_vm.hasUpdatedSettingsLocally ? 'opacity-25 disabled' : 'button--mint',
    attrs: {
      "loading": _vm.isUpdating,
      "disabled": !_vm.hasUpdatedSettingsLocally
    },
    on: {
      "click": function ($event) {
        return _vm.saveSettings();
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tUpdate Settings\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('small', [_vm._v("Please note: You will still receive important account information.")]), _vm._v(" "), _c('links-footer', {
    staticClass: "justify-start mt-10",
    attrs: {
      "override-email": "concierge@extra.app"
    }
  })], 1) : _vm._e()]), _vm._v(" "), !_vm.settings || !_vm.hasToken ? _c('div', {
    staticClass: "pt-24"
  }, [_c('p', {
    staticClass: "my-8 text-xl leading-8 text-center"
  }, [_vm._v("\n\t\t\t\t\tOpen this page from your Extra App to continue\n\t\t\t\t")])]) : _vm._e()], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };